import { ButtonBase, styled } from '@mui/material'
import { BarChart as BarChartIcon, TableChartOutlined as TableChartOutlinedIcon } from '@mui/icons-material'

export const BarIcon = styled(BarChartIcon)`
  color: ${props => props.theme.palette.brand.primary};
  width: 90%;
  margin: 0 auto;
  outline: none;

  &.MuiSvgIcon-root {
    font-size: 2em;
  }
`

export const TableIcon = styled(TableChartOutlinedIcon)`
  color: ${props => props.theme.palette.brand.primary};
  width: 90%;
  margin: 0 auto;
  outline: none;
`

const BaseIconButton = styled(ButtonBase)`
  align-items: center;
  background-color: transparent;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.fontSize};
  font-weight: 700;
  height: ${({ size }) => {
    if (size === 'large') {
      return '48px'
    } else if (size === 'small') {
      return '28px'
    } else {
      return '38px'
    }
  }};
  justify-content: center;
  margin: ${props => props.margin};
  padding: 0;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  text-decoration: none;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    color 0.15s ease-in-out;
  user-select: none;
  width: ${props => props.width};
  &.singleBtn svg {
    opacity: 0.3;
  }

  &.Mui-disabled {
    cursor: not-allowed;
    pointer-events: none;
    user-select: none;
    color: ${props => props.theme.palette.brand.gray1};

    & svg {
      opacity: 0.3;
    }

    &.singleBtn svg {
      color: ${props => props.theme.palette.blue[50]};
      opacity: 1;
    }
  }

  & .MuiTouchRipple-root {
    display: none;
  }
  &:focus {
    background-color: ${props => props.theme.palette.custom.gray[50.1]};
  }
`

export const OutlinedButton = styled(BaseIconButton)`
  background-color: 'transparent';
  border: 1px solid ${props => props.theme.palette.brand.gray1};
  border-radius: 0.25rem;
  width: 40px;
  height: 40px;
  color: ${({ disabled, theme }) => (disabled ? theme.palette.brand.white : theme.palette.brand.black1)};

  &.MuiButtonBase-root {
    border: 1px solid ${props => props.theme.palette.brand.gray1};
    border-radius: 4px;
    margin: 0 0 0 8px;
  }
`
